import React, { useEffect, useState } from 'react'
import { useAppShellStore } from '@bitechsystems/btappshell'
import { shallow } from 'zustand/shallow'
import { useQuery } from '@tanstack/react-query'
import { useGoRestAPI } from '@bitechsystems/services'

export interface HomeStatComms {
  email?: {
    sent: Array<number>
    received: Array<number>
    pending: Array<number>
    errors: Array<number>
  }
  sms?: {
    sent: Array<number>
    received: Array<number>
    pending: Array<number>
    errors: Array<number>
  }
  calls?: {
    sent: Array<number>
    received: Array<number>
    pending: Array<number>
    errors: Array<number>
  }
  whatsapp?: {
    sent: Array<number>
    received: Array<number>
    pending: Array<number>
    errors: Array<number>
  }
}
export interface HomeStatDataFields {
  actions?: {
    open: number
    done: number
  }
  comms?: HomeStatComms
  tasks?: {
    open: number
    done: number
  }
  lastchanges?: {
    timestamp?: string
    entity?: string
    entitytype?: string
    action?: string
  }[]
  lastlogins?: {
    timestamp?: string
    expiretime?: string
    useragent?: string
    location?: string
  }[]
  client_totals?: {
    leads?: number
    active?: number
    all?: number
  }
  communication?: {
    whatsapp?: number
    email?: number
  }
  sessions?: {
    users?: number
    sessions?: number
  }
}

export function useHomeStatsQueryData(): [HomeStatDataFields, boolean, string] {
  const [userDetail] = useAppShellStore((state) => [state.userDetail], shallow)
  const goapi = useGoRestAPI('')

  const query = useQuery<any>({
    queryKey: [`webui_homestats_${userDetail.id}`],
    queryFn: () => {
      return goapi?.proc?.('/gsql/webui_homestats', [])
    },
    networkMode: 'offlineFirst',
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 2,
    retryDelay: 60,
    gcTime: 10 * 60 * 1000,
  })

  let tm = ''
  if (query.dataUpdatedAt > 0) {
    tm = new Date(query.dataUpdatedAt).toISOString()
  }
  return [
    query.data?.[0]?.p_data ?? {},
    query.isSuccess && query.status == 'success',
    tm,
  ]
}
